var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("HIV True/False")]),_c('p',[_vm._v("Select True or False for each statement.")])])}
var staticRenderFns = []

export { render, staticRenderFns }